import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const DoctrorsList = () => {
  const { sellersWithProducts, loading } = useSelector((state: RootState) => state.segment);

  if (loading) {
    return <div className="text-center p-5">Loading doctors...</div>;
  }

  if (!sellersWithProducts || sellersWithProducts.length === 0) {
    return <div className="text-center p-5 text-muted h5">No doctors found for the selected criteria.</div>;
  }

  return (
    <>
      <div className=" display-max">
        {sellersWithProducts.map((seller) => {
          const firstProduct = seller.digitalProducts?.[0];
          const sellerIdStr = typeof seller.sellerId === "object" ? (seller.sellerId as any)?._id || (seller.sellerId as any)?._id : seller._id;
          const sellerName = typeof seller.sellerId === "object" ? (seller.sellerId as any)?.name : (seller.name || "Doctor");
          
          return (
            <div className=" card border-radius-lg mt-3 mb-4 shadow-dark p-3" key={seller._id}>
              <div className=" d-flex justify-content-between align-items-center">
                <div className=" w-100">
                  <div className=" d-flex justify-content-start align-items-center gap-3">
                    <div>
                      <Link to={`/DoctorPro/${sellerIdStr}`}>
                        <img
                          src={seller.banners?.[0]?.url || "../../assets/img/team-1.jpg"}
                          alt={sellerName}
                          className=" img-fluid border-radius-section"
                          style={{ width: "120px", height: "120px", objectFit: "cover" }}
                        />
                      </Link>
                    </div>
                    <div>
                      <div>
                        <b className=" text-black fw-bold fs-5">
                          {sellerName}
                        </b>
                        <div>
                          <b className=" text-black fw-normal text-sm letter-spacing-1">
                            {seller.businessInfo?.businessInfo.department || "Physician"}
                          </b>
                        </div>
                        <div>
                          <b className=" text-black-50 fw-normal text-sm letter-spacing-1">
                            {seller.businessInfo?.businessInfo.ownershipType || "Senior Consultant"}
                          </b>
                        </div>
                        <div>
                          <b className=" text-black fw-normal text-sm letter-spacing-1">
                            <i className="fi fi-sr-marker text-xs"></i> {seller.businessInfo?.businessInfo?.city || "Unknown Location"}
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" w-50 text-end">
                  <div>
                    <Link to={`/DoctorPro/${sellerIdStr}`}>
                      <button className=" btn btn-outline-dark btn-md border-radius-40 w-70 mb-2">
                        View Profile
                      </button>
                    </Link>
                  </div>
                  <div>
                    <Link to={`/CustomerDetails/${sellerIdStr}/${firstProduct?._id || "none"}`}>
                      <button className=" btn btn-dark btn-md border-radius-40 w-70">
                        Book Appointment
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className=" display-mini display-mob pb-7">
        {sellersWithProducts.map((seller) => {
          const firstProduct = seller.digitalProducts?.[0];
          const sellerIdStr = typeof seller.sellerId === "object" ? (seller.sellerId as any)?.sellerId || (seller.sellerId as any)?._id : seller.sellerId;
          const sellerName = typeof seller.sellerId === "object" ? (seller.sellerId as any)?.name : (seller.name || "Doctor");

          return (
            <div className=" card border-radius-lg mt-3 mb-4 shadow border w-97 mx-auto p-3" key={seller._id}>
              <div className=" d-flex justify-content-between align-items-center">
                <div className=" w-100">
                  <div className=" d-flex justify-content-start align-items-center gap-3">
                    <div>
                      <Link to={`/DoctorPro/${sellerIdStr}`}>
                        <img
                          src={seller.banners?.[0]?.url || "../../assets/img/team-1.jpg"}
                          alt={sellerName}
                          className=" img-fluid border-radius-section"
                          style={{ width: "80px", height: "80px", objectFit: "cover" }}
                        />
                      </Link>
                    </div>
                    <div>
                      <div>
                        <b className=" text-black fw-bold fs-5">
                          {sellerName}
                        </b>
                        <div className=" lh-sm">
                          <b className=" text-black fw-normal text-xs letter-spacing-1">
                            {seller.businessInfo?.businessInfo.department || "Physician"}
                          </b>
                        </div>
                        <div>
                          <b className=" text-black-50 fw-normal text-xs letter-spacing-1">
                            {seller.businessInfo?.businessInfo.ownershipType || "Senior Consultant"}
                          </b>
                        </div>
                        <div>
                          <b className=" text-black fw-normal text-xs letter-spacing-1">
                            <i className="fi fi-sr-marker text-xs"></i> {seller.businessInfo?.businessInfo.city || "Unknown Location"}
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" w-100 d-flex mx-auto text-center gap-3 mt-3">
                <div className=" w-100">
                  <Link to={`/DoctorPro/${sellerIdStr}`}>
                    <button className=" btn btn-outline-dark btn-md border-radius-40 w-100 mb-2">
                      View Profile
                    </button>
                  </Link>
                </div>
                <div className=" w-100">
                  <Link to={`/CustomerDetails/${sellerIdStr}/${firstProduct?._id || "none"}`}>
                    <button className=" btn btn-dark btn-md border-radius-40 w-100">
                      Book Appointment
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DoctrorsList;
